module.exports = __webpack_public_path__ + "static/media/github.1c51ada5.svg";